import useConfiguration from '@/composables/configuration/configuration'
import useEventBuffer from '@/composables/eventBuffer/eventBuffer'

const BANNER_EVENT_NAME = 'anzu.forum.promoDisplay'
const BANNER_TYPE_TOP = 'topTeaser'
const BANNER_TYPE_POST = 'postTeaser'

const BANNER_SHOW_LOGIN_NAME = 'anzu.forum.user.signIn'
const BANNER_SHOW_SWITCH_ACC_NAME = 'anzu.forum.user.switch'

let lastBannerId = 0

export default function useBannerManager() {
  const { configuration } = useConfiguration()
  const loginBannerDisabled = configuration.widget.loginBannerDisabled

  const generateBannerId = (): string => {
    if (configuration.widget.loginBannerDisabled) {
      return ''
    }
    lastBannerId++
    return configuration.widget.loginBannerPrefixId + lastBannerId
  }

  const propagateEvent = (bannerId: string, type = BANNER_TYPE_POST): void => {
    const { dispatchEvent } = useEventBuffer()
    if (configuration.widget.loginBannerDisabled) {
      return
    }

    dispatchEvent(BANNER_EVENT_NAME, {
      divId: bannerId,
      type: type,
    })
  }

  const propagatePostBannerEvent = (bannerId: string): void => {
    propagateEvent(bannerId, BANNER_TYPE_POST)
  }

  const propagateTopBannerEvent = (bannerId: string): void => {
    propagateEvent(bannerId, BANNER_TYPE_TOP)
  }

  return {
    loginBannerDisabled,
    generateBannerId,
    propagatePostBannerEvent,
    propagateTopBannerEvent,
  }
}

export function useDefaultBannerActions() {
  const { configuration } = useConfiguration()

  const propagateLoginEvent = (): void => {
    window.dispatchEvent(new CustomEvent(BANNER_SHOW_LOGIN_NAME))
  }

  const propagateSwitchAccountEvent = (): void => {
    window.dispatchEvent(new CustomEvent(BANNER_SHOW_SWITCH_ACC_NAME))
  }

  const loginBannerFallbackDisabled =
    configuration.widget.loginBannerFallbackDisabled

  return {
    loginBannerFallbackDisabled,
    propagateLoginEvent,
    propagateSwitchAccountEvent,
  }
}
